<template>
  <modal
    v-if="visible"
    :visible="visible"
    @click-outside-modal="$emit('close')"
  >
    <div
      class="flex w-full max-w-2xl justify-center px-4"
      style="minwidth: 30vw"
    >
      <div
        class="relative flex w-full flex-col items-start rounded bg-white p-8"
        :class="containerClass"
      >
        <img
          class="absolute right-4 top-4 h-4 w-4 cursor-pointer"
          src="@/assets/close-icon.svg"
          alt="close icon"
          @click="$emit('close')"
        />

        <div class="flex flex-col">
          <h3 class="text-left text-3xl text-dark-blue">
            Add New Payment Method
          </h3>
          <!-- <slot></slot> -->
          <div class="mb-6 mt-2 text-left text-base text-body-color">
            Create a new payment method allowed by the currently selected
            payment term ({{ termName }}).
          </div>
          <div>
            <!-- Create new payment method -->
            <div class="flex flex-col gap-3 md:grid md:grid-cols-2">
              <div
                v-if="allowedPaymentMethods?.includes('ach')"
                class="w-full md:flex"
              >
                <round-radio-button-terms
                  class="w-full"
                  value="ach"
                  name="modal_new_payment_method_type"
                  item="ACH Deposit"
                  term="ach_deposit"
                  :handle-click="updateSelection"
                  :checked="selection === 'ach'"
                />
              </div>
              <div
                v-if="allowedPaymentMethods?.includes('check')"
                class="w-full md:flex"
              >
                <round-radio-button
                  class="w-full"
                  value="check"
                  item="Check"
                  name="modal_new_payment_method_type"
                  :handle-click="updateSelection"
                  :checked="selection === 'check'"
                />
              </div>
              <div
                v-if="allowedPaymentMethods?.includes('wire')"
                class="w-full md:flex"
              >
                <round-radio-button
                  class="w-full"
                  value="wire"
                  item="Wire Transfer"
                  name="modal_new_payment_method_type"
                  :handle-click="updateSelection"
                  :checked="selection === 'wire'"
                />
              </div>
              <div
                v-if="allowedPaymentMethods?.includes('cad_eft')"
                class="w-full md:flex"
              >
                <round-radio-button
                  class="w-full"
                  value="cad_eft"
                  item="Canada EFT"
                  name="modal_new_payment_method_type"
                  :handle-click="updateSelection"
                  :checked="selection === 'cad_eft'"
                />
              </div>
              <div
                v-if="allowedPaymentMethods?.includes('comcheck')"
                class="w-full md:flex"
              >
                <round-radio-button
                  class="w-full"
                  value="comcheck"
                  item="Comchek"
                  name="modal_new_payment_method_type"
                  :handle-click="updateSelection"
                  :checked="selection === 'comcheck'"
                />
              </div>
              <div
                v-if="allowedPaymentMethods?.includes('efs')"
                class="w-full md:flex"
              >
                <round-radio-button
                  class="w-full"
                  value="efs"
                  item="EFS Check"
                  name="modal_new_payment_method_type"
                  :handle-click="updateSelection"
                  :checked="selection === 'efs'"
                />
              </div>
              <div
                v-if="allowedPaymentMethods?.includes('echeck')"
                class="w-full md:flex"
              >
                <round-radio-button
                  class="w-full"
                  value="echeck"
                  item="eCheck"
                  name="modal_new_payment_method_type"
                  :handle-click="updateSelection"
                  :checked="selection === 'echeck'"
                />
              </div>
            </div>
            <!-- <div v-if="existingPaymentMethodTypes?.includes(selection)" class="pt-6">
            <radio-button-large
              :item="warningText"
              :active="checkboxConfirmed"
              :handleSelect="handleAccept"
              name="confirmation"
            ></radio-button-large>
          </div> -->
          </div>
        </div>
        <div class="mt-8 flex w-full justify-end gap-4">
          <!-- <div class="inline-block"> -->
          <div class="w-24">
            <button-main
              variant="secondary"
              @click="$emit('close')"
            >
              Cancel
            </button-main>
          </div>
          <div class="w-40">
            <button-main
              :disabled="isButtonDisabled"
              :class="[
                isButtonDisabled ? 'cursor-not-allowed' : 'cursor-pointer',
              ]"
              @click="emitAdd(selection)"
            >
              Continue
            </button-main>
          </div>
          <!-- </div> -->
        </div>
      </div>
    </div>
  </modal>
</template>

<script>
import Modal from '@/components/modals/Modal.vue';
import ButtonMain from '@/components/Button.vue';
import RoundRadioButton from '@/components/RoundRadioButton.vue';
import RoundRadioButtonTerms from '@/components/RoundRadioButtonTerms.vue';
// import RadioButtonLarge from "@/components/RadioButtonLarge.vue";
// import { isSuccessfulServerResponse, toastResponse } from "@/common/handleServerResponse"

export default {
  name: 'NewPaymentMethodTypeModal',
  components: {
    Modal,
    ButtonMain,
    RoundRadioButton,
    RoundRadioButtonTerms,
    // RadioButtonLarge
  },
  props: {
    visible: Boolean,
    containerClass: String,
    allowedPaymentMethods: Array,
    termName: String,
    carrierActivePaymentMethods: Array,
  },
  emits: ['close', 'add'],
  setup(_, { emit }) {
    const onCancel = () => {
      emit('close');
    };

    return {
      onCancel,
    };
  },
  data() {
    return {
      selection: null,
      checkboxConfirmed: false,
    };
  },
  computed: {
    existingPaymentMethodTypes() {
      return this.carrierActivePaymentMethods?.map((method) => method?.is_type);
    },
    showCarrierDeactivationWarning() {
      return this.existingPaymentMethodTypes?.includes(this.selection);
    },
    isButtonDisabled() {
      // return !this.selection || (this.showCarrierDeactivationWarning && !this.checkboxConfirmed);
      return !this.selection;
    },
    warningText() {
      let methodText;
      switch (this.selection) {
        case 'ach':
          methodText = 'ACH Deposit';
          break;
        case 'check':
          methodText = 'Check';
          break;
        case 'wire':
          methodText = 'Wire Transfer';
          break;
        case 'cad_eft':
          methodText = 'Canada EFT';
          break;
        case 'comcheck':
          methodText = 'Comchek';
          break;
        case 'efs':
          methodText = 'EFS Check';
          break;
        case 'echeck':
          methodText = 'eCheck';
          break;
        default:
          methodText = '';
      }
      return (
        'Note: You already have an active ' +
        methodText +
        ' payment method. If you add a new ' +
        methodText +
        ' payment method, your existing ' +
        methodText +
        ' payment method will be deactivated. If you would like to proceed, click this checkbox to confirm.'
      );
    },
  },
  methods: {
    updateSelection(e) {
      this.selection = e?.target?.value;
    },
    emitAdd(value) {
      this.$emit('add', value);
    },
    handleAccept(e) {
      this.checkboxConfirmed = e?.target?.checked;
    },
  },
};
</script>
